<template>
  <div class="btn-group">
    <button
      class="btn--primary btn--main"
      @click="handleOnClick()"
      :disabled="disabledMapButton"
      style="padding: 0.8rem 1rem;"
    >
      {{ placeholderText }}
    </button>
    <button
      class="btn--primary btn--main"
      style="
        border-left: 1px solid white;
        min-width: 10px;
        padding: 0.8rem 1rem;
        margin-left: -1px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      "
      @click="toggleMenu()"
      v-if="general.userId && validLayers.length"
      :disabled="disabledMapButton"
    >
      <i class="fa fa-caret-down"></i>
    </button>
    <div class="dropdown-menu" v-if="showMenu && validLayers.length">
      <WizardEventDispatcher :event="'click'" :target="'button-add-comment'">
        <a
          @click="selectAndOpenNewComment()"
          v-show="!general.layout.newComment"
          class="btn-in-dropdown"
        >
          Přidat komentář do mapy ...
        </a>
      </WizardEventDispatcher>
      <br />
      <span
        v-show="!general.layout.newPin && general.userId"
        class="pin-buttons-header"
        >Přidat pracovní pin do:</span
      >
      <WizardEventDispatcher :event="'click'" :target="'button-add-pin'">
        <div v-for="layer in validLayers" :key="layer.id">
          <ToggleSwitch layout-part="layer" :layer-id="layer.id"></ToggleSwitch>
          <a
            @click="selectAndOpenNewPin(layer)"
            class="btn-in-dropdown pin-button"
            v-show="!general.layout.newPin && general.userId && layer.isActive"
          >
            {{ layer.name }}
          </a>
          <span
            v-show="!general.layout.newPin && general.userId && !layer.isActive"
          >
            {{ layer.name }}
          </span>
        </div>
      </WizardEventDispatcher>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';
import ToggleSwitch from '@/components/ToggleSwitch.vue';

export default {
  components: {
    WizardEventDispatcher,
    ToggleSwitch
  },
  data() {
    return {
      showMenu: false,
      placeholderText: 'Přidat komentář do mapy ...',
      selectedType: 'comment',
      selectedLayer: null,
      disabledMapButton: false
    };
  },
  computed: {
    ...mapState(['general', 'layers']),
    ...mapGetters({
      validLayers: ['layers/getCanAddPinLayers']
    })
  },
  props: {
    placeholder: {
      type: String,
      required: false
    },
    closeOnOutsideClick: {
      type: [Boolean],
      default: true
    }
  },
  mounted() {
    if (this.placeholder) {
      this.placeholderText = this.placeholder;
    }

    if (this.closeOnOutsideClick) {
      document.addEventListener('click', this.clickHandler);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickHandler);
  },

  methods: {
    handleOnClick() {
      if (this.selectedType) {
        if (this.selectedType == 'comment') {
          this.openNewComment();
        }

        if (this.selectedType == 'pin') {
          this.openNewPin(this.selectedLayer);
        }
      }
    },
    selectAndOpenNewComment() {
      this.selectAddNewComment();
      this.openNewComment();
    },
    selectAndOpenNewPin(layer) {
      this.selectAddNewPin(layer);
      this.openNewPin(layer.id);
    },
    selectAddNewComment() {
      this.selectedType = 'comment';
      (this.selectedLayer = null),
        (this.placeholderText = `Přidat komentář do mapy ...`);
      this.$store.dispatch('general/setMapButtonSelectedLayerId', null);

      this.showMenu = false;
    },
    selectAddNewPin(layer) {
      this.selectedType = 'pin';
      this.selectedLayer = layer.id;
      this.placeholderText = `Přidat pracovní pin do vrstvy ${layer.name}`;
      this.$store.dispatch('general/setMapButtonSelectedLayerId', layer.id);

      this.showMenu = false;
    },
    openNewComment() {
      this.$store.dispatch('general/setLayoutOption', ['newComment', true]);
    },
    openNewPin(layerId) {
      this.$store.dispatch('general/setLayoutOption', ['newPin', true]);
      this.$store.dispatch('general/setNewPinLayerId', layerId);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    clickHandler(event) {
      const { target } = event;
      const { $el } = this;
      if (!$el.contains(target) && target.type !== 'checkbox') {
        this.showMenu = false;
      }
    }
  },
  watch: {
    validLayers(newValue) {
      if (!newValue.length) {
        this.selectAddNewComment();
      }
      if (this.general.mapButtonSelectedLayerId && this.general.userId) {
        const layer = _.find(newValue, {
          id: Number(this.general.mapButtonSelectedLayerId)
        });

        if (layer && layer.canAddIndividualPin === 1) {
          this.selectAddNewPin(layer);
        }
      }
    },
    'general.layout.newPin'(newValue) {
      if (newValue) {
        this.disabledMapButton = true;
      } else {
        this.disabledMapButton = false;
      }
    },
    'general.layout.newComment'(newValue) {
      if (newValue) {
        this.disabledMapButton = true;
      } else {
        this.disabledMapButton = false;
      }
    }
  }
};
</script>
<style scoped>
.btn--main {
  z-index: auto;
  box-shadow: none;
  border: 1px solid transparent;
}

.btn--main::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border-radius: inherit;
  box-shadow: 0 0.3rem 0.6rem rgba(0, 4, 8, 0.25);
  z-index: -1;
  transition: box-shadow 0.5s;
}

.dropdown-menu {
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow-y: auto;
  background: #f2f2f2;
  box-shadow: 0 0.3rem 0.6rem rgba(0, 4, 8, 0.25);
  padding: 5px;
  padding-top: 10px;
}
.btn--primary:disabled {
  background: #dddddd;
}
.btn-in-dropdown {
  font-weight: 700;
  width: max-content;
}
/* .btn-in-dropdown.pin-button {
  margin-left: 15px;
} */
.pin-buttons-header {
  color: gray;
  margin-bottom: 5px;
}
</style>
